import { graphql } from "generated/gql";

export const getMaterialTypesDocument = graphql(/* GraphQL */ `
  query GetAllMaterialTypes {
    materialTypes {
      id
      name
      code
    }
  }
`);

export const getProvenanceCategoriesDocument = graphql(/* GraphQL */ `
  query GetAllProvenanceCategories {
    provenanceCategories {
      codeId
      name
      ordering
    }
  }
`);

export const createAccessionDocument = graphql(/* GraphQL */ `
  mutation CreateAccession($accession: CreateAccession!) {
    createAccession(accession: $accession) {
      id
      accessionNumber
    }
  }
`);

export const CountryFieldsFragment = graphql(/* GraphQL */ `
  fragment CountryFields on Country {
    codeId
    name
  }
`);

export const getCountriesDocument = graphql(/* GraphQL */ `
  query GetCountries {
    countries {
      ...CountryFields
    }
  }
`);

export const getManualAccessionNumberErrorsDocument = graphql(/* GraphQL */ `
  query GetManualAccessionNumberErrors(
    $organisationSubdomain: String!
    $collectionSiteSlug: String!
    $accessionNumberPrefix: Int
    $accessionNumberSuffix: Int
    $exogenousAccessionNumber: String
  ) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      site: collectionSiteBySlug(slug: $collectionSiteSlug) {
        errors: manualAccessionNumberErrors(
          accessionNumberPrefix: $accessionNumberPrefix
          accessionNumberSuffix: $accessionNumberSuffix
          exogenousAccessionNumber: $exogenousAccessionNumber
        )
      }
    }
  }
`);

export const uploadFileDocument = graphql(/* GraphQL */ `
  mutation UploadFile($fileName: String!, $size: Int!, $contentType: String!) {
    uploadFile(fileName: $fileName, size: $size, contentType: $contentType) {
      uploadUrl
      headers {
        key
        value
      }
    }
  }
`);
